import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';

@Injectable()
export class DiversityService {
  constructor(private _httpService: BackendService) {}

  public getLatestDiversityCheck(): Observable<any> {
    return this._httpService.get('getLatestDiversityCheck');
  }

  public acceptDiversityCheck(): Observable<any> {
    return this._httpService.post('acceptDiversityCheck', {});
  }
}
